import { ChannelOrganizationStatus } from '../reducers/order-detail';

const SHOPIFY_CHANNELS = ['shopify', 'shopify-sandbox'];

export default function getTaxAndDutyInclusivitySetting(
  channelOrganization: io.flow.channel.v0.models.ChannelOrganization | null | undefined,
  channelOrganizationStatus: ChannelOrganizationStatus,
  orderSettings: io.flow.internal.v0.models.OrderSettings | null | undefined,
  order: io.flow.v0.models.Order,
): io.flow.v0.enums.TaxAndDutyInclusivitySetting | undefined {
  if (channelOrganizationStatus !== 'loaded') {
    return undefined;
  }

  const isShopifyChannel = channelOrganization
    && SHOPIFY_CHANNELS.includes(channelOrganization.channel.id);

  if (isShopifyChannel) {
    return orderSettings?.tax_and_duty_inclusivity_setting;
  }

  const setting = order.attributes?.tax_and_duty_inclusivity_setting;
  return setting as io.flow.v0.enums.TaxAndDutyInclusivitySetting | undefined;
}
